const routes = {
    path: 'marketingcloud',
    name: 'MarketingCloud_Painel',
    component: () => import('./MarketingCloud.vue'),
    meta: {
        rules: ['INTEGRAPE-01', 'INTEGRAPE-02', 'INTEGRAPE-05', 'INTEGRAPE-06', 'INTEGRAPE-07'],
    },
    children: [
        {
            path: 'reguas-disparadas/:id',
            name: 'MarketingCloud_ReguasDisparadas_Detalhar',
            component: () => import('./abas/reguasdisparadas/Detalhar.vue'),
            meta: {
                rules: ['INTEGRAPE-03'],
            },
        },
    ],
};

export default routes;
